import React from 'react';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import { formatPhysicalAddress, formatTenantName, formatUnitName } from 'shared/utils/formatters';
import { getTenantPath } from 'shared/routes/tenant';
import { getUnitPath } from 'shared/routes/building';

/**
 * @param {Object} props
 * @param {Object} props.tenantMoveState - Tenant move state object
 */
export default function TenantMoveSummary({ tenantMoveState }) {
  const {
    currentBuilding,
    currentUnit,
    isSameBuilding,
    isSameUnit,
    tenant,
  } = tenantMoveState;

  return (
    <Grid size={6}>
      <hr />
      {isSameUnit && (
        <p>
          {'Updated '}
          <Link to={getTenantPath(tenant.id)}>
            {formatTenantName(tenant)}
            &apos;s
          </Link>
          {' data.'}
        </p>
      )}
      {(!isSameUnit && isSameBuilding) && (
        <p>
          {'Moved '}
          <Link to={getTenantPath(tenant.id)}>
            {formatTenantName(tenant)}
          </Link>
          {' to '}
          <Link to={getUnitPath(currentBuilding.id, currentUnit.id)}>
            {formatUnitName(currentUnit.name)}
          </Link>
          .
        </p>
      )}
      {!isSameBuilding && (
        <p>
          {'Moved '}
          <Link to={getTenantPath(tenant.id)}>
            {formatTenantName(tenant)}
          </Link>
          {' to '}
          <Link to={getUnitPath(currentBuilding.id, currentUnit.id)}>
            {formatPhysicalAddress(currentBuilding, formatUnitName(currentUnit.name))}
          </Link>
          .
        </p>
      )}
    </Grid>
  );
}
